export function getShouldMigrateToNewForm(locationsData, selectedLocation) {
	if (!selectedLocation) {
		return false;
	}

	if (!locationsData) {
		return false;
	}

	const locationInfo = locationsData?.byId?.[selectedLocation];

	if (locationInfo !== undefined) {
		return locationInfo.isNewStateTaxView === false && locationInfo.supportsNewStateTaxView === true;
	} 

	return false;
}
export function isNewStateTaxWithholdingForm(locationsData, selectedLocation) {
	if (!locationsData) {
		return false;
	}

	const hasSavedLocation = Boolean(locationsData?.selected);

	const locationInfo = locationsData?.byId?.[selectedLocation];
	const isNewStateTaxView = locationInfo?.isNewStateTaxView || false

	if (!selectedLocation) {
		// If the user doesn't have a selected location AND they don't have a saved work location (as in, they have never saved a state withholding).
		// In that case, we should default to new form since that's what we want users to use moving forward.
		return !hasSavedLocation && isNewStateTaxView
	}

	return isNewStateTaxView;
}
